var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "employees-card-bottom card-box",
          staticStyle: { "padding-top": "0px" },
        },
        [
          _c("el-form", { staticClass: "from-s", attrs: { inline: true } }, [
            _c("div", { staticClass: "flex-row flex-col" }, [
              _c(
                "div",
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "tabs",
                      on: { "tab-click": _vm.activeClick },
                      model: {
                        value: _vm.activeVal,
                        callback: function ($$v) {
                          _vm.activeVal = $$v
                        },
                        expression: "activeVal",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "部门汇报", name: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "部门统计", name: "4" },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: { label: "抄送我的", name: "5" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "splitLine" }),
          _vm._v(" "),
          _vm.activeVal == "3"
            ? _c(
                "div",
                { staticClass: "card-box" },
                [
                  _c("oaFromBox", {
                    attrs: {
                      isAddBtn: false,
                      isViewSearch: false,
                      search: _vm.search,
                      total: _vm.totalPage,
                    },
                    on: { confirmData: _vm.confirmData },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticClass: "mt-10",
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "elTable",
                          attrs: {
                            data: _vm.tableData,
                            height: _vm.tableHeight,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.name"),
                              prop: "name",
                              width: "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.department"),
                              "min-width": "100",
                              prop: "frame_name",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.worktoday"),
                              "min-width": "250",
                              prop: "finish",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.finish,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "textover3",
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              3474526367
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.tomorrowplan"),
                              "min-width": "250",
                              prop: "plan",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.types != 3
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              scope.row.plan,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "textover3",
                                                  },
                                                  [_vm._v(_vm._s(item))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _c("span", [_vm._v("--")]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3518861820
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("user.work.dailytype"),
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getDailyTypes(scope.row.types)
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2908938355
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("user.work.creationtime"),
                              prop: "created_at",
                              width: "160",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("public.operation"),
                              "show-overflow-tooltip": true,
                              width: _vm.tableFrom.type == 0 ? 160 : 60,
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [
                                                "user:daily:department:check",
                                              ],
                                              expression:
                                                "['user:daily:department:check']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(
                                                scope.row.daily_id,
                                                true,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("public.check")) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.tableFrom.type == 0 &&
                                      new Date(scope.row.end_time).getTime() >
                                        new Date().getTime()
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  scope.row.reply !== "",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEditt(
                                                    scope.row.daily_id,
                                                    false,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("public.edit")
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.tableFrom.type == 0 &&
                                      new Date(scope.row.end_time).getTime() >
                                        new Date().getTime()
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  scope.row.reply !== "",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelete(
                                                    scope.row.daily_id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                删除\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              483799988
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "page-fixed" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.tableFrom.page,
                              "page-size": _vm.tableFrom.limit,
                              "page-sizes": [15, 20, 30],
                              total: _vm.totalPage,
                              layout: "total,sizes, prev, pager, next, jumper",
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeVal == "4"
            ? _c(
                "el-row",
                { staticClass: "flexBox" },
                [
                  _c(
                    "el-col",
                    { staticClass: "left", attrs: { span: 14 } },
                    [
                      _c(
                        "div",
                        { staticClass: "title" },
                        [
                          _c("oaFromBox", {
                            attrs: {
                              isAddBtn: false,
                              isTotal: false,
                              isViewSearch: false,
                              search: _vm.search1,
                              sortSearch: false,
                            },
                            on: { confirmData: _vm.confirmData },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "title-text" }, [
                            _c("span", { staticClass: "tips1" }, [
                              _vm._v(_vm._s(_vm.thePreviousDay) + " 填写情况"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "tips2" }, [
                              _vm._v("每日 00:00 ～ 23:59 统计"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "classification" }, [
                        _c("div", { staticClass: "content" }, [
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(_vm.total || 0)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("提交结果"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("span", { staticClass: "num color1" }, [
                            _vm._v(_vm._s(_vm.submit || 0)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text color1" }, [
                            _vm._v("已提交"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("span", { staticClass: "num color2" }, [
                            _vm._v(_vm._s(_vm.no_submit || 0)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text color2" }, [
                            _vm._v("未提交"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "mt14 tabs",
                          on: { "tab-click": _vm.submitTypeFn },
                          model: {
                            value: _vm.submitType,
                            callback: function ($$v) {
                              _vm.submitType = $$v
                            },
                            expression: "submitType",
                          },
                        },
                        [
                          _c("el-tab-pane", {
                            attrs: { label: "已提交", name: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-tab-pane", {
                            attrs: { label: "未提交", name: "2" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "inTotal" }, [
                        _vm._v("共 " + _vm._s(_vm.totalSubmit) + " 条"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        { ref: "elTable", attrs: { data: _vm.table } },
                        [
                          _c("el-table-column", {
                            attrs: { label: "姓名", prop: "name" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "部门", prop: "frame_name" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "汇报类型", prop: "types" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getDailyTypes(scope.row.types)
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2908938355
                            ),
                          }),
                          _vm._v(" "),
                          _vm.submitType == "1"
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "提交时间",
                                  prop: "created_at",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.submitType == "1"
                            ? _c("el-table-column", {
                                attrs: { label: "操作", prop: "", width: "80" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEdit(
                                                    scope.row.daily_id,
                                                    true,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("public.check")
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3590963396
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.submitFrom.page,
                          "page-size": _vm.submitFrom.limit,
                          "page-sizes": [15, 20, 30],
                          total: _vm.totalSubmit,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleLimit,
                          "current-change": _vm.handleChange,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "right", attrs: { span: 10 } },
                    [
                      _vm.tableFrom.types !== 2
                        ? _c("calendar", {
                            ref: "week",
                            attrs: {
                              activeVal: _vm.activeVal,
                              calendar: _vm.calendar,
                              type: _vm.tableFrom.types,
                            },
                            on: {
                              currentTime: _vm.currentTimeFn,
                              switchTime: _vm.switchTime,
                            },
                          })
                        : _c("div", [
                            _c("div", { staticClass: "month" }, [
                              _c("i", {
                                staticClass: "el-icon-arrow-left",
                                on: { click: _vm.leftFn },
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.year) + "年\n            "
                              ),
                              _c("i", {
                                staticClass: "el-icon-arrow-right",
                                on: { click: _vm.rightFn },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "monthBox" },
                              _vm._l(_vm.monthList, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickMonth(item, index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "box",
                                        class:
                                          _vm.active == index
                                            ? "active-add"
                                            : "",
                                      },
                                      [
                                        _vm._v(_vm._s(item.name) + " "),
                                        _vm.getCalendarDay(item.time)
                                          ? _c("span", {
                                              staticClass:
                                                "iconfont iconjindu-qita",
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "tips" }, [
                              _c("span", {
                                staticClass: "iconfont icontishi2",
                              }),
                              _vm._v(" 日历中的红点表示有下属未提交月报"),
                            ]),
                          ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeVal == "5"
            ? _c(
                "div",
                [
                  _c("oaFromBox", {
                    attrs: {
                      isAddBtn: false,
                      isViewSearch: false,
                      search: _vm.search3,
                      total: _vm.totalPage,
                    },
                    on: { confirmData: _vm.confirmData },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticClass: "mt-10",
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "elTable",
                          attrs: {
                            data: _vm.tableData,
                            height: _vm.tableHeight,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.name"),
                              prop: "name",
                              width: "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.department"),
                              "min-width": "100",
                              prop: "frame_name",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.worktoday"),
                              "min-width": "250",
                              prop: "finish",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.finish,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "textover3",
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              3474526367
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.tomorrowplan"),
                              "min-width": "250",
                              prop: "plan",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.types != 3
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              scope.row.plan,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "textover3",
                                                  },
                                                  [_vm._v(_vm._s(item))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _c("span", [_vm._v("--")]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3518861820
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("user.work.dailytype"),
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getDailyTypes(scope.row.types)
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2908938355
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("user.work.creationtime"),
                              prop: "created_at",
                              width: "160",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("public.operation"),
                              "show-overflow-tooltip": true,
                              width: _vm.tableFrom.type == 0 ? 160 : 60,
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [
                                                "user:daily:department:check",
                                              ],
                                              expression:
                                                "['user:daily:department:check']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(
                                                scope.row.daily_id,
                                                true,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("public.check")) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.tableFrom.type == 0 &&
                                      new Date(scope.row.end_time).getTime() >
                                        new Date().getTime()
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  scope.row.reply !== "",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEditt(
                                                    scope.row.daily_id,
                                                    false,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("public.edit")
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.tableFrom.type == 0 &&
                                      new Date(scope.row.end_time).getTime() >
                                        new Date().getTime()
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  scope.row.reply !== "",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelete(
                                                    scope.row.daily_id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                删除\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              483799988
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-fixed" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.tableFrom.page,
                          "page-size": _vm.tableFrom.limit,
                          "page-sizes": [15, 20, 30],
                          total: _vm.totalPage,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("addBox", {
        ref: "addBox",
        attrs: {
          "daily-id": _vm.dailyIndex,
          "edit-data": _vm.editData,
          "edit-id": _vm.editId,
        },
        on: { tableList: _vm.tableList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }